import { Box, Skeleton } from '@mui/material'
import React from 'react'
import useResponsive from './Responsive';

export const SkeletonCom = () => {
    return (
        <Skeleton variant="rounded" width={"100%"} height={300} style={{ borderRadius: "40px" }} animation="wave" />
    )
}

export const TextSkeleton = ({ width, line, margin, sx }) => {
    return (
        <Box sx={{ width: width || 300, margin: margin, ...sx }}>
            {[...Array(line ?? 3)].map((_, index) => (
                <Skeleton
                    key={index}
                    variant="text"
                    sx={{
                        fontSize: '1rem',
                        ...sx,
                    }}
                    animation="wave"
                />
            ))}
        </Box>
    );
};


export const ImgSkeleton = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{ borderRadius: "40px" }}
            width="100%"
            height={isSmallScreen ? "260px" : "400px"} />
    )
}